const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const OpenMapPopup = {
	// properties
	$domBody: $('body'),
	$domMapPopup: $('.js-map-popup'),
	$domMapPopupInner: $('.js-map-popup__inner'),
	$domOpenMapPopupLink: $('.js-open-map-popup__link'),
	$domMapPopupCloseIcon: $('.js-map-popup__close'),
	classActive: 'is-active',
	classHasTransition: 'has-transition',
	classPreventScroll: 'prevent-scroll',

	//initialize
	init: function() {
		if ($('.js-map__block').length > 0) {
			this.onClickMarkerShowPopup();
			this.onClickCloseBtnHidePopup();
			this.closeMenuOnOutsideContainerClick();
			Global.escKey(OpenMapPopup.closePopup);
		}
	},

	// on clicking the marker on the google map, show popup
	onClickMarkerShowPopup: function() {
		$('.js-map__block').on('click', '.js-open-map-popup__link', (e) => {
			const popupNum = $(e.currentTarget).attr('data-popup');
			OpenMapPopup.$domBody.addClass(OpenMapPopup.classPreventScroll);
			$(`.js-map-popup-${popupNum}`).addClass(OpenMapPopup.classActive);
			$(`.js-map-popup-${popupNum}`).addClass(OpenMapPopup.classHasTransition);
		});
	},

	// on clicking the icon close, close the pop-up window
	onClickCloseBtnHidePopup: function() {
		OpenMapPopup.$domMapPopupCloseIcon.each(function(i, el) {
			$(el).on('click', function() {
				OpenMapPopup.closePopup();
			});
		});
	},

	closePopup: function() {
		OpenMapPopup.$domBody.removeClass(OpenMapPopup.classPreventScroll);
		OpenMapPopup.$domMapPopup.removeClass(OpenMapPopup.classActive);
	},

	/* @description close menu if click outside container */
	closeMenuOnOutsideContainerClick: function() {
		OpenMapPopup.$domBody.on('mouseup', function(e) {
			e.preventDefault();
			if (OpenMapPopup.$domMapPopup.hasClass(OpenMapPopup.classActive) && !OpenMapPopup.$domMapPopupInner.is(e.target) && OpenMapPopup.$domMapPopupInner.has(e.target).length === 0 && !OpenMapPopup.$domMapPopupCloseIcon.is(e.target)) {
				OpenMapPopup.closePopup();
			}
		});
	},
};

export default OpenMapPopup;
